"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tsenum_1 = require("@gradecam/tsenum");
exports.StringArrayEncoding = tsenum_1.MakeEnum({
    Base64: 'base64',
    Rc4: 'rc4'
});
